import { useTranslation } from 'next-i18next';
import { CheckSmallCircleFillIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { AiGradientButton } from './components/AiGradientButton';
export const SaveQuizAction = ({
  onConfirm,
  onCancel,
  disabled = false
}: {
  onConfirm: () => void;
  onCancel: () => void;
  disabled?: boolean;
}) => {
  const {
    t
  } = useTranslation(['common', 'build']);
  return <div className={'flex w-full justify-end gap-xs'} data-sentry-component="SaveQuizAction" data-sentry-source-file="SaveQuizAction.tsx">
      <Button className="z-10" intent={'neutral'} variant={'transparent'} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="SaveQuizAction.tsx">
        {t('common:global.cancel.button')}
      </Button>
      <AiGradientButton disabled={disabled} className="z-10 min-w-[200px] grow tablet-sm:grow-0" onClick={onConfirm} data-sentry-element="AiGradientButton" data-sentry-source-file="SaveQuizAction.tsx">
        <CheckSmallCircleFillIcon size={'md'} data-sentry-element="CheckSmallCircleFillIcon" data-sentry-source-file="SaveQuizAction.tsx" />
        {t('build:similarQuiz.modal.add')}
      </AiGradientButton>
    </div>;
};